<template>
    <div class="img-swiper-box" :class="{ isSwiper: list.length > 2}">
        <div class="swiper-box" v-if="list.length > 2" >
            <swiper class="content-swiper" :options="isOnly ? swiperOption: swiperOption1" ref="bannerSwiper">
                <swiper-slide v-for="(item, index) in list" :key="`banner${index}`">
                    <div class="content-img-box">
                        <img class="content-img" :src="item.url">
                        <div class="detail" :class="{isNotAuto: isNotAuto}">
                            <p class="title">{{item.main}}</p>
                            <p class="des" v-if="item.des">{{item.des}}</p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div v-if="isOnly" class="swiper-pagination"></div>
            <div v-else class="swiper-pagination1"></div>
        </div>
        <div v-else class="content-box">
            <div class="content-img-box" v-for="(item, index) in list" :key="index">
                <img class="content-img" :src="item.url">
                <div class="detail" :class="{isNotAuto: isNotAuto}">
                    <p class="title">{{item.main}}</p>
                    <p class="des" v-if="item.des">{{item.des}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        isNotAuto: {
            type: Boolean,
            default: false
        },
        isOnly: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            swiperOption: {
                notNextTick: true,
                direction: 'horizontal',
                autoplay: false,
                slidesPerView: 2.02,
                slidesPerGroup: 2,
                spaceBetween: 0,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            swiperOption1: {
                notNextTick: true,
                direction: 'horizontal',
                autoplay: false,
                slidesPerView: 2.02,
                slidesPerGroup: 2,
                spaceBetween: 0,
                loop: false,
                pagination: {
                    el: '.swiper-pagination1',
                    clickable: true
                }
            },
        }
    }
}
</script>
<style lang="scss" scoped>
.img-swiper-box{
    padding: 0px 20px;
    .content-box{
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        .content-img-box{
            margin-right: 10px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
            border-radius:4px;
            box-sizing: content-box;
            width: 162px;
            .content-img{
                width: 100%;
            }
            .detail{
                padding: 10px;
                color:#282828;
                text-align: left;
                .title{
                    font-size:12px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:500;
                    line-height:17px;
                }
                .des{
                    margin-top: 6px;
                    font-size:10px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    line-height:14px;
                }
            }
            &.isNotAuto {
                height: 70px;
            }
            &:last-of-type{
                margin-right: 0px;
            }
        }
    }
    .swiper-box{
        position: relative;
        .content-swiper{
            padding: 10px 20px 30px;
        }
        .content-img-box{
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
            border-radius:4px;
            box-sizing: content-box;
            margin-right: 10px;
            .content-img{
                width: 100%;
            }
            .detail{
                padding: 10px;
                color:#282828;
                text-align: left;
                .title{
                    font-size:12px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:500;
                    line-height:17px;
                }
                .des{
                    margin-top: 6px;
                    font-size:10px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    line-height:14px;
                }
                &.isNotAuto {
                    height: 70px;
                }
            }
        }
        .swiper-pagination1{
            position: absolute;
            z-index: 10; 
        }
        ::v-deep .swiper-pagination-bullets{
            left: 50%;
            bottom: 10px;
            transform: translateX(-50%);
            .swiper-pagination-bullet{
                width:15px;
                height:6px;
                background:#F0F2F6;
                border-radius:3px;
                margin-right: 5px;
                opacity: 1;
                outline: none;
                margin-right: 0px;
                margin-right: -4px;
                &.swiper-pagination-bullet-active{
                    background:#4F89FF;
                    border-radius:3px;
                    outline: none;
                    position: relative;
                    z-index: 11;
                }
                &:last-of-type{
                    margin-right: 0px;
                }
            }
            .swiper-pagination1-bullet{
                width:15px;
                height:6px;
                background:#F0F2F6;
                border-radius:3px;
                margin-right: 5px;
                opacity: 1;
                outline: none;
                margin-right: 0px;
                &.swiper-pagination1-bullet-active{
                    background:#4F89FF;
                    border-radius:3px;
                    outline: none;
                }
            }
        }
    }
    &.isSwiper{
        padding: 0px;
    }
}
</style>